import { CircleIcon, ExclamatoryIcon, TickIcon } from "../../assets/assets";
import { dateAndTimeConverter } from "../../utils/constants";
import "./Incidents.css";

export function IncidentsCard({ incidents, userType, incidentOnClick }) {
  if (!incidents || Object.keys(incidents).length === 0) {
    return (
      <div
        className="padding-large font-family-gilroy-medium font-color-secondary"
        data-cy="INCIDENTS-EMPTY-STATE"
      >
        No incidents found
      </div>
    );
  }

  const filteredIncidents = Object.values(incidents).filter((data) =>
    data.affectedUsers?.includes(userType)
  );

  if (filteredIncidents.length === 0) {
    return (
      <div
        className="padding-large font-family-gilroy-medium font-color-secondary"
        data-cy="INCIDENTS-NO-ACCESS"
      >
        No incidents available for your role
      </div>
    );
  }

  return (
    <>
      {Object.values(incidents).map((data) => {
        const isClosed = data.status === "CLOSED";
        const isAllowed = data.affectedUsers?.includes(userType);

        if (!isAllowed) return null;

        const id = data.incidentId || data.documentId;

        return (
          <div
            key={id}
            data-cy={`INCIDENT-CARD-${data.incidentName}-${data.status}`.toUpperCase()}
            className={`${
              isClosed ? "" : "background-red-linear-gradient"
            } inherit-parent-width border-radius-4px padding-left-default padding-right-default padding-top-large padding-bottom-large margin-bottom-large flex-justify-content-space-between flex-align-items-center border-bottom-1px-e5e5e5`}
            onClick={() => incidentOnClick(id)}
          >
            {/* LEFT CONTENT */}
            <div
              className="width-80-percentage"
              data-cy="INCIDENT-CARD-CONTENT"
            >
              {/* Title */}
              <div
                className="font-family-gilroy-medium text-capitalize text-overflow-ellipsis"
                data-cy="INCIDENT-TITLE"
              >
                {data.incidentName}
              </div>

              {/* Status / ETA */}
              <div
                className="font-size-smaller padding-top-default"
                data-cy="INCIDENT-STATUS-TEXT"
              >
                {isClosed
                  ? `COMPLETED AT: ${
                      data.resolutionAt
                        ? dateAndTimeConverter(
                            data.resolutionAt,
                            "cardDateWithoutDay"
                          )
                        : "N/A"
                    }`
                  : `ESTIMATED COMPLETION: ${
                      data.resolutionAt
                        ? getEstimateTime(data.resolutionAt)
                        : "N/A"
                    }`}
              </div>

              {/* Created Date */}
              <div
                className="font-size-smaller padding-top-default font-color-secondary"
                data-cy="INCIDENT-CREATED-AT"
              >
                {dateAndTimeConverter(data?.createdAt, "cardDateWithoutDay")}
              </div>
            </div>

            {/* ICON */}
            <div data-cy={`INCIDENT-ICON-${isClosed ? "CLOSED" : "OPEN"}`}>
              {isClosed ? (
                <TickIcon color="#00A000" />
              ) : (
                <ExclamatoryIcon color="#E64539" />
              )}
            </div>
          </div>
        );
      })}
    </>
  );
}

export function SelectedIncident({ incident }) {
  if (!incident) return null;

  const isClosed = incident.status === "CLOSED";

  return (
    <>
      <div className="padding-left-default padding-right-default padding-top-medium padding-bottom-large border-bottom-1px-e5e5e5">
        {/* HEADER */}
        <div className="flex-justify-content-space-between flex-align-items-center">
          <div
            className="font-family-gilroy-medium text-capitalize"
            data-cy="SELECTED-INCIDENT-TITLE"
          >
            {incident.incidentName}
          </div>

          <div
            className="padding-left-large"
            data-cy={`SELECTED-INCIDENT-ICON-${isClosed ? "CLOSED" : "OPEN"}`}
          >
            {isClosed ? (
              <TickIcon color="#00A000" />
            ) : (
              <ExclamatoryIcon color="#E64539" />
            )}
          </div>
        </div>

        {/* DETAILS */}
        <div className="flex-justify-content-space-between flex-align-items-center">
          <div
            className="font-size-smaller padding-top-default"
            data-cy="SELECTED-INCIDENT-ETA"
          >
            {`ESTIMATED COMPLETION: ${
              incident.resolutionAt
                ? getEstimateTime(incident.resolutionAt)
                : "N/A"
            }`}
          </div>

          <div
            className="font-size-smaller padding-top-default font-color-secondary"
            data-cy="SELECTED-INCIDENT-CREATED-AT"
          >
            {dateAndTimeConverter(incident.createdAt, "cardDateWithoutDay")}
          </div>
        </div>
      </div>

      {/* PROGRESS */}
      <div className="padding-top-large" data-cy="SELECTED-INCIDENT-PROGRESS">
        <TrackProgress data={incident.steps} />
      </div>
    </>
  );
}

function TrackProgress(props) {
  return (
    <>
      <div className=" font-size-small padding-bottom-large">
        TRACK PROGRESS
      </div>
      {props.data
        ?.sort((first, second) => {
          return second.updatedAt - first.updatedAt;
        })
        ?.map((data, index) => (
          <div key={index}>
            <div className="display-flex ">
              <div>
                <CircleIcon height={8} color={"#4E4E4E"} />
              </div>
              <div className="display-flex inherit-parent-width flex-justify-content-space-between">
                <div className="padding-left-large width-80-percentage text-overflow-ellipsis">
                  {data.name}
                </div>

                <div className=" display-flex flex-justify-content-center flex-align-items-center">
                  <div className="display-flex flex-align-items-center font-size-smaller font-color-secondary">
                    {data.updatedAt
                      ? dateAndTimeConverter(
                          data.updatedAt,
                          "cardDateWithoutDay"
                        )
                      : "N/A"}
                  </div>
                </div>
              </div>
            </div>
            <div className="display-flex">
              <div className="width-16px flex-align-items-center flex-justify-content-center">
                {index !== props.data.length - 1 && (
                  <div
                    style={{ width: "2px" }}
                    className={`inherit-parent-height grey-dashed-border `}
                  />
                )}
              </div>
              <div className=" inherit-parent-width flex-justify-content-space-between">
                <div className="padding-left-large padding-top-small font-size-small parent-width_-68px ">
                  {data.description}
                </div>
                <div className=" font-size-smaller  font-color-secondary">
                  {dateAndTimeConverter(data.updatedAt, "Time")}
                </div>
              </div>
            </div>

            {data.description && !(index === props.data.length - 1) && (
              <div className="display-flex">
                <div className="width-16px flex-align-items-center flex-justify-content-center">
                  <div
                    style={{ width: "2px", height: "9px" }}
                    className="grey-dashed-border"
                  />
                </div>
                <div className="padding-left-large padding-top-large" />
              </div>
            )}
          </div>
        ))}
    </>
  );
}

const getEstimateTime = (timestamp) => {
  const days = Math.round((timestamp - +new Date()) / 86400000);
  const hours = Math.round((timestamp - +new Date()) / 3600000);
  const minutes = Math.round((timestamp - +new Date()) / 60000);

  if (days >= 1) {
    return `${days} DAY${days === 1 ? "" : "S"}`;
  } else if (hours >= 1) {
    return `${hours} HR${days === 1 ? "" : "S"}`;
  } else if (minutes >= 1) {
    return `${minutes} MIN${days === 1 ? "" : "S"}`;
  } else {
    return "N/A";
  }
};
